module.exports = __webpack_public_path__ + "img/heart.78faaf65.svg";